import { Link } from 'react-router-dom';

const highlights = [
  {
    title: 'Extensive Product Database',
    desc: 'Thousands of curated product finds spanning 14 categories, from sneakers and streetwear to accessories and perfumes. Our Basetao spreadsheet is constantly refreshed with the latest discoveries.',
    icon: 'ri-database-2-line',
  },
  {
    title: 'Verified & Trusted Platform',
    desc: 'Basetao is a legitimate shopping agent with years of operational history, secure payment processing, and reliable warehouse services. Thousands of global shoppers use it daily.',
    icon: 'ri-shield-check-line',
  },
  {
    title: 'Smart Shipping Options',
    desc: 'Multiple shipping methods with transparent pricing let you choose the best balance of speed and cost. Learn about Basetao shipping cost calculators and warehouse consolidation.',
    icon: 'ri-ship-line',
  },
  {
    title: 'Deals & Savings',
    desc: 'Stay updated with the latest Basetao coupon codes, discount offers, and promotional deals to maximize your savings on every purchase through our spreadsheet links.',
    icon: 'ri-coupon-line',
  },
];

export default function ReviewSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-primary-600 uppercase tracking-widest mb-3">Why Trust Us</p>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-4">
            The Basetao Spreadsheet Advantage
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Our Basetao spreadsheet platform combines product discovery, verified reviews, and smart shopping tools in one place.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {highlights.map((item) => (
            <div
              key={item.title}
              className="flex gap-4 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70"
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/article/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Read the Complete Basetao Guide
          </Link>
        </div>
      </div>
    </section>
  );
}